import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const CONFLUENCE_LINKS_FRAGMENT = gqlTagGira`
    fragment ConfluenceLinksFragment on ConfluenceLinks {    
            linkedConfluencePages {
                pageCount
                pages {
                    ... on ConfluencePage {
                        id
                        globalId
                        href
                        title
                        type
                        lastUpdatedContext {
                            user {
                                key
                                accountId
                                emailAddress
                                avatarUrl
                                displayName
                                active
                            }
                        }
                    }
                    ... on FailedRemoteLink {
                        id
                        error
                        link {
                            id
                            globalId
                            href
                        }
                        repairLink {
                            href
                        }
                    }
                }
            }
    }
`;
